
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M8.5 5.667c3.52 0 6.375-.952 6.375-2.125S12.021 1.417 8.5 1.417s-6.375.951-6.375 2.125S4.979 5.667 8.5 5.667M14.875 8.5c0 1.176-2.833 2.125-6.375 2.125S2.125 9.675 2.125 8.5"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M2.125 3.542v9.916c0 1.176 2.833 2.125 6.375 2.125s6.375-.949 6.375-2.125V3.542"}})])
          )
        }
      }
    